.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-block-size: 100vh;
  padding: 2rem 1rem;
  background-color: var(--surface);
}
